import React from 'react';
import i18n from 'app/common/lib/i18n';
import loadable from '@loadable/component';
import { Box, Spinner } from 'gestalt';

const FullPageSignup = loadable(() =>
  import(/* webpackChunkName: "FullPageSignup" */ 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignup'),
);

export default function FullPageSignupLoader(props) {
  return (
    <FullPageSignup
      {...props}
      fallback={
        <Box display="flex" justifyContent="center" alignItems="center">
          <Spinner accessibilityLabel={i18n._('Loading signup form')} show />
        </Box>
      }
    />
  );
}
